import { getClientCacheLoaderData } from '@/hooks/useClientCacheLoaderData';
import { ErrorCode } from '@/shared/constant/error/ErrorCode';
import type { ErrorCodeMessageType } from '@/shared/constant/error/ErrorCodeMessageType';
import React from 'react';
import { ErrorContent } from '../error-content/ErrorContent';

export type RouteErrorProps = {
  error: unknown;
};

export function RouteError(props: RouteErrorProps) {
  const { error } = props;

  const customError = React.useMemo<ErrorCodeMessageType>(() => {
    console.error(error);
    const errorMessage = (() => {
      if (error instanceof Error) {
        return error.message;
      }

      return String(error);
    })();

    return {
      errorCode: (() => {
        if (errorMessage === 'Failed to fetch') {
          return ErrorCode.NetworkError;
        }
        return ErrorCode.Unknown;
      })(),
      errorMessage,
      extra: {
        hideBuiltWith: getClientCacheLoaderData()?.docsDataState?.docsBaseConfig?.hideBuiltWith ?? true,
      },
    };
  }, [error]);

  return (
    <ErrorContent errorCodeMessage={customError} isShowReloadButton docsIdTypeData={undefined} />
  );
}
